// Basemap choices for the live map. Kept outside MapPage so the account
// menu's Settings can list them without pulling in the (lazy) map bundle.
export const BASEMAPS = [
  { key: 'dark', label: 'Dark', hint: 'Conditions stand out' },
  { key: 'streets', label: 'Streets', hint: 'All roads and places' },
  { key: 'satellite', label: 'Satellite', hint: 'Aerial imagery (US)' },
];
export const BASEMAP_KEY = 'heatwatch:basemap';
